import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { XCircle, Save } from "react-feather";
import { POST } from "../../../api/adminApi";
import { toast } from "react-toastify";

export default function SMSBulkCreate() {
  const history = useHistory();
  const [msg, setMsg] = useState("");
  const [phones, setPhones] = useState("");

  function handleMessageChange(e) {
    setMsg(e.target.value);
  }

  function handlePhonesChange(e) {
    setPhones(e.target.value);
  }

  function onSubmit(e) {
    e.preventDefault();

    if (!msg) {
      toast.error("Введите сообщение");
      return;
    }

    // Convert comma-separated string to array of strings and trim whitespace
    const phoneList = phones
      .split(",")
      .map((phone) => phone.trim())
      .filter((phone) => phone !== "");

    if (phoneList.length === 0) {
      toast.error("Введите номера телефонов");
      return;
    }

    for (let i = 0; i < phoneList.length; i++) {
      if (!phoneList[i].startsWith("998")) {
        toast.error(
          `Номер ${phoneList[i]} должен начинаться с 998 (без плюса)`,
        );
        return;
      }
      if (phoneList[i].includes("+")) {
        toast.error(`Номер ${phoneList[i]} не должен содержать знак +`);
        return;
      }
      if (phoneList[i].length !== 12) {
        toast.error(`Номер ${phoneList[i]} должен состоять из 12 цифр`);
        return;
      }
    }

    async function create() {
      const response = await POST("/services/admin/api/bulk-sms", {
        message: msg,
        phones: phoneList,
      });
      if (response?.success) {
        history.push("/admin/sms-bulk");
        toast.success("Успешно добавлен");
      }
    }

    create();
  }

  return (
    <div className="mb-1 mx-3 ">
      <h3 className="mb-5 mt-5">Создать смс рассылку</h3>
      <form onSubmit={onSubmit} autoComplete="off">
        <div
          className="admin-card p-4 pt-12 d-flex flex-column justify-content-between"
          style={{ height: "70vh" }}
        >
          <div className="mb-1 d-flex">
            <div className="">
              <div className="d-flex align-items-center mb-2 gap-2">
                <label
                  style={{ width: "120px" }}
                  className="color-grey text-end text-nowrap"
                >
                  Сообщение
                </label>
                <div>
                  <textarea
                    value={msg}
                    name="message"
                    className="input-control"
                    onChange={handleMessageChange}
                    style={{ width: "300px", minHeight: "100px" }}
                    required
                  />
                </div>
              </div>
              <div className="d-flex align-items-center mb-2 gap-2">
                <label
                  style={{ width: "120px" }}
                  className="color-grey text-end text-nowrap"
                >
                  Телефоны
                </label>
                <div>
                  <textarea
                    value={phones}
                    name="phones"
                    className="input-control"
                    onChange={handlePhonesChange}
                    placeholder="Введите номера телефонов через запятую"
                    style={{ width: "300px", minHeight: "100px" }}
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end">
            <Link to="/admin/sms-bulk" className="mr-3">
              <button className="btn text-white btn-bg-primary d-flex align-items-center">
                <XCircle size={14} className="mr-2" />
                Отмена
              </button>
            </Link>
            <button
              className="btn text-white btn-bg-success d-flex align-items-center"
              type="submit"
            >
              <Save size={14} className="mr-2" />
              Сохранить
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
